import type { AvailableBlockCalendarEvent } from '../../../types';
import { EventCardWrapper } from '../../column-events/event-card-wrapper';

interface Props {
  event: AvailableBlockCalendarEvent;
}
export const AvailableBlockEvent = ({ event }: Props) => {
  return <EventCardWrapper eventType={'availableBlock'}>{event.eventType}</EventCardWrapper>;
};
